<div class="modal-header">
  @if (isRioEmployee ) {
    <h4 class="modal-title" id="modal-title">
      {{ "customVendorReporting.details.dataEvaluationTitle" | cxTranslate }}
    </h4>
  } @else {
    <h4 class="modal-title" id="modal-title">
      {{ "customVendorReporting.details.title" | cxTranslate }}
    </h4>
  }
  <button type="button" class="close" aria-describedby="modal-title" (click)="modal.dismiss('Cross click')">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <div class="container-fluid">
    <div class="vendorReportingDetails">
      <div class="row">
        <div class="col-2 col-sm-2">
          <p> {{ 'customVendorReporting.manufacturer' | cxTranslate }} :</p>
        </div>
        <div class="col-4 col-sm-4">
          <p>{{ reportTransferData?.manufacturer }}</p>
        </div>
        <div class="col-2 col-sm-2">
          <p> {{ 'customVendorReporting.reportCountry' | cxTranslate }}:</p>
        </div>
        <div class="col-4 col-sm-4">
          <p>{{ reportTransferData?. reportCountry}}</p>
        </div>
      </div>
      <div class="row">
        <div class="col-2 col-sm-2">
          <p> {{ 'customVendorReporting.reportTransferType' | cxTranslate }}:</p>
        </div>
        <div class="col-4 col-sm-4">
          <p>{{ reportTransferData?.reportTransferType }}</p>
        </div>
        <div class="col-2 col-sm-2">
          <p> {{ 'customVendorReporting.reportChannel' | cxTranslate }}:</p>
        </div>
        <div class="col-4 col-sm-4">
          <p>{{ reportTransferData?.reportChannel}}</p>
        </div>
      </div>
      <div class="row">
        <div class="col-2 col-sm-2">
          <p> {{ 'customVendorReporting.reportTransferPeriod' | cxTranslate }}:</p>
        </div>
        <div class="col-4 col-sm-4">
          <p>{{ reportTransferData?.reportTransferPeriod }}</p>
        </div>
        <div class="col-2 col-sm-2">
          <p> {{ 'customVendorReporting.b2bUnit' | cxTranslate }}:</p>
        </div>
        <div class="col-4 col-sm-4">
          <p>{{ reportTransferData?.b2bUnit}}</p>
        </div>
      </div>
      <div class="row">
        <div class="col-2 col-sm-2">
          <p> {{ 'customVendorReporting.transferDate' | cxTranslate }}:</p>
        </div>
        <div class="col-4 col-sm-4">
          <p>{{ reportTransferData?.transferDate | cxDate}}</p>
        </div>
        <div class="col-2 col-sm-2">
          <p> {{ 'customVendorReporting.fileName' | cxTranslate }}:</p>
        </div>
        <div class="col-4 col-sm-4">
          <p>{{ reportTransferData?.fileName }}</p>
        </div>
      </div>
      <div class="row">
        <div class="col-2 col-sm-2">
          <p> {{ 'customVendorReporting.reportTransferStatus' | cxTranslate }}:</p>
        </div>
        <div class="col-4 col-sm-4 status">
          <p ngClass="status-{{getReportTransferStatusColor(reportTransferStatusEnum[reportTransferData.reportTransferStatus])}}">{{ 'customVendorReporting.reportTransferStatuses.' + reportTransferData?.reportTransferStatus |
          cxTranslate}}</p>
        </div>
      </div>
      <div class="row">
        <div class="col-2 col-sm-2">
          <p> {{ 'customVendorReporting.timestamp' | cxTranslate }}:</p>
        </div>
        <div class="col-4 col-sm-4">
          <p>{{ reportTransferData?.timeStamp | cxDate:'dd.MM.YYYY hh:mm' }}</p>
        </div>
      </div>
    </div>
    <ng-container *ngComponentOutlet="manufaturerSpecificDetailsComponent"></ng-container>
  </div>
</div>
